export default "__VITE_ASSET__C3aGY0DR__"